

<mat-dialog-content class="mat-typography">
  <h2>Invoice Details - #{{item}}</h2>
  @if (hasTableRows()) {
    @for (row of responseData?.data?.tableRows; track row) {
      <div class="invoice-table-scroll-container mat-elevation-z1" style="display: flex; flex-direction: column; gap: 16px;">
        <mat-card>
          <mat-card-content>
            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 16px;">
              <div><strong>Account Number:</strong> {{ row.accountNumber }}</div>
              <!-- <div><strong>Work Order Number:</strong> {{ row.workOrderNumber }}</div> -->
             
              <div><strong>Invoice Date:</strong> {{ row.invoiceDate }}</div>
              <div><strong>Invoice Number:</strong> {{ row.invoiceNumber }}</div>
            </div>
          </mat-card-content>
        </mat-card>
        <mat-card>
          <mat-card-content>
        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 16px;">
          <div><strong>Created Date:</strong> {{ row.createdDate | date }}</div>
          <div><strong>Modified Date:</strong> {{ row.modifiedDate | date }}</div>
        </div>
        </mat-card-content>
        </mat-card>
        <mat-card>
          <mat-card-content>
        <div>
          <strong>Line Items:</strong>
          <div style="margin-top: 8px; overflow-x: auto;" [ngClass]="{'table-scroll': row.lineItems && row.lineItems.length > 5}">
            @if (hasLineItems(row)) {
              <table style="width: 100%; border-collapse: collapse; text-align: left;" class="responsive-table">
                <thead>
                  <tr style="border-bottom: 1px solid rgba(0,0,0,0.12);">
                    <th style="padding: 8px 16px 8px 0;">Product</th>
                    <th style="padding: 8px 16px; width: 40%;">Description</th>
                    <th style="padding: 8px 16px; width: 40%;">Work Order Number</th>
                    <th style="padding: 8px 16px;">Bill Code</th>
                    <th style="padding: 8px 16px;">Cost($)</th>
                    <th style="padding: 8px 0 8px 16px;">Tax($)</th>
                  </tr>
                </thead>
                <tbody>
                  @for (item of row.lineItems; track item) {
                    <tr style="border-bottom: 1px solid rgba(0,0,0,0.06);">
                      <td style="padding: 8px 16px 8px 0;">{{ item.LineProduct }}</td>
                      <td style="padding: 8px 16px;">{{ item.LineDesc }}</td>
                      <td style="padding: 8px 16px;">{{ item.TrackingID }}</td>
                      <td style="padding: 8px 16px;">{{ item.BillCode }}</td>
                      <td style="padding: 8px 16px;">{{ item.LineItemCost }}</td>
                      <td style="padding: 8px 0 8px 16px;">{{ item.LineItemTax }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            }
            @if (!hasLineItems(row)) {
              <div style="padding: 8px 0; color: rgba(0,0,0,0.6);">No line items</div>
            }
          </div>
        </div>
        </mat-card-content>
        </mat-card>
        <mat-card>
        <mat-card-content>
        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 16px;">
          <div><strong>Invoice Total($):</strong> {{ row.invoiceTotal }}</div>
          <div><strong>Tax Invoice Total($):</strong> {{ row.taxInvoiceTotal }}</div>
        </div>
        </mat-card-content>
        </mat-card>
      </div>
    }
  }

  @if (isError()) {
    <div style="color: var(--mat-sys-error, #b00020); margin-top: 16px;">
      Error: {{ responseData?.message || 'Failed to load data.' }}
    </div>
  }

  @if (!responseData && !isError()) {
    <div style="margin-top: 16px;">
      Loading data...
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="center">
  <button mat-flat-button color="primary" mat-dialog-close cdkFocusInitial>Close</button>
</mat-dialog-actions>
